import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import { makeStyles } from '@material-ui/core/styles';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';

const useStyles = makeStyles((theme) => ({
  bold: { fontWeight: 'bold' },
  item2: { color: theme.palette.table.cell.purple },
  item3: { color: theme.palette.primary.contrastText },
  ecpm: { color: theme.palette.table.cell.green },
}));

const ShoppingCell = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { type, itemKey, headsMap, rowObj } = props;
  let item1 = '';
  let item2 = '';
  let item3 = '';
  let toolTip = '';
  if (itemKey === 'MOB_SESSION_ROAS') {
    item1 = 'MOB_SESSION_ROAS';
    item2 = 'TRGT_MOB_SESSION_ROAS';
    item3 = 'MOB_SESSION_ORDER_AMT';
    toolTip = t('세션 매출 중 모비온 광고를 통해 발생한 매출');
  } else if (itemKey === 'BROWSER_SESSION_ROAS') {
    item1 = 'BROWSER_SESSION_ROAS';
    item2 = 'TRGT_BROWSER_SESSION_ROAS';
    item3 = 'BROWSER_SESSION_ORDER_AMT';
    toolTip = t('광고 클릭 후 30분이내 매출(페이지 이탈 전)');
  } else if (itemKey === 'SESSION_ROAS') {
    item1 = 'SESSION_ROAS';
    item2 = 'TRGT_SESSION_ROAS';
    item3 = 'SESSION_ORDER_AMT';
    toolTip = t(
      '모비온 광고 클릭 후 브라우저를 닫지 않고 결제한 매출로 타사 매출이 포함됨'
    );
  } else if (itemKey === 'DIRECT_ROAS') {
    item1 = 'DIRECT_ROAS';
    item2 = 'TRGT_DIRECT_ROAS';
    item3 = 'DIRECT_ORDER_AMT';
    toolTip = t('모비온 광고 클릭 후 직접매출시간(Default 24시간) 이내 매출');
  } else if (itemKey === 'ROAS') {
    item1 = 'ROAS';
    item2 = 'TRGT_ROAS';
    item3 = 'ORDER_AMT';
    toolTip = t('모비온 광고 클릭 후 총매출시간(Default 30일) 이내 매출');
  } else if (itemKey === 'ECPM') {
    item1 = 'ECPM';
    item2 = 'TRGT_ECPM';
    toolTip = t('광고 1000회 노출 당 광고 수익');
  }
  return type === 'head' ? (
    <InfoTitleArea
      title={getHeadObj(headsMap, item1).label + '(' + t('쇼핑') + ')'}
      tooltipTitle={toolTip}
      iconType="fainfoCircle"
    />
  ) : (
    <div className={clsx(item1 === 'SESSION_ROAS' && classes.bold)}>
      <div>
        {makeRowColumn(
          rowObj[item1],
          getHeadObj(headsMap, item1).type,
          getHeadObj(headsMap, item1).format
        )}
        {itemKey === 'ECPM' && <br />}
        {!!item2 && (
          <span
            className={clsx(item1 === 'ECPM' && classes.ecpm, classes.item2)}
          >
            (
            {makeRowColumn(
              rowObj[item2],
              getHeadObj(headsMap, item2).type,
              getHeadObj(headsMap, item2).format
            )}
            )
          </span>
        )}
      </div>
      {!!item3 && (
        <p className={classes.item3}>
          {makeRowColumn(
            rowObj[item3],
            getHeadObj(headsMap, item3).type,
            getHeadObj(headsMap, item3).format
          )}
        </p>
      )}
    </div>
  );
};

export default ShoppingCell;
